import React, { useState, useRef } from "react";
import Navbar from "../components/common/Navbar";
import DocumentsPageHeader from "../components/common/DocumentsPageHeader";
import CaseListTable from "../components/email-case-list/case-list-table/CaseListTable";
import AllDocumentsList from "../components/all-case-list/case-table/AllDocumentsList";
import baseUrl from "../config/baseUrl";
import "../styles/Documents.css";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import MultiFileUpload from "../components/email-case-list/MultiFileUpload";
import { TabName } from "../utils/setTabName";
import FaxOutlinedIcon from "@mui/icons-material/FaxOutlined";

/*** Main component for listing all the faxed documents & for showing all the faxed documents inside
 * a selected group/document (breadcrumb-only navigation - no internal tab strip). ***/
const FaxCaseList = () => {
  const [uploadButton, setShowUploadButton] = useState(false);
  const tableRef = useRef(null);

  // Replaces the old array-of-tabs model: null shows the main Fax Cases
  // list, a row object shows that row's documents (same data CaseListTable
  // always passed into the tab it used to open).
  const [selectedGroup, setSelectedGroup] = useState(null);
  // AllDocumentsList manages its own internal "specific document open" state;
  // this mirrors just the title so the breadcrumb's last segment can show it
  // in place of the group name while a document is open.
  const [openDocumentTitle, setOpenDocumentTitle] = useState(null);

  const addDocumentTab = (document) => {
    setSelectedGroup(document);
    setOpenDocumentTitle(null);
  };

  const backToList = () => {
    setSelectedGroup(null);
    setOpenDocumentTitle(null);
  };

  return (
    <div className="document-container">
      <div className="navbar">
        <Navbar />
      </div>
      <div
        className="document-content documents-zoom-scroll-scope"
        ref={tableRef}
        style={{
          scrollBehavior: "smooth",
          scrollTimingFunction: "ease-in-out",
        }}
      >
        <DocumentsPageHeader
          showBreadcrumb={!!selectedGroup}
          showHeader={!openDocumentTitle}
          breadcrumbs={[
            { label: "Data Center" },
            {
              label: "Incoming Faxes",
              onClick: selectedGroup ? backToList : undefined,
            },
            ...(selectedGroup ? [{ label: TabName(selectedGroup) }] : []),
          ]}
          icon={FaxOutlinedIcon}
          title="Incoming Faxes"
          description="Review documents received by fax"
          /* Upload button - temporarily hidden from UI; uncomment to re-enable
          action={
            <button className="add-document" onClick={() => setShowUploadButton(!uploadButton)}>
              <CloudUploadIcon sx={{ fontSize: 18 }} />
              Upload
            </button>
          }
          */
          headerSpacingClass="py-3"
        />
        <div className="tab-content">
          {uploadButton ? (
            <MultiFileUpload
              setShowUploadButton={setShowUploadButton}
              documentSourceType="Fax"
            />
          ) : selectedGroup ? (
            <AllDocumentsList
              caseList="fax"
              sourceDetails={selectedGroup.document_source_details}
              createdAt={selectedGroup.created_at}
              categoryName={selectedGroup.category}
              folderName=""
              assigned="FALSE"
              onOpenDocumentChange={setOpenDocumentTitle}
            />
          ) : (
            <CaseListTable
              tableRef={tableRef}
              caseList="fax"
              addDocumentTab={addDocumentTab}
              apiLink={`${baseUrl}/api/get-records-of-email-fax-scanned-docs`}
              folderName={document.uncategorized_from_name}
              onOpenDocumentChange={setOpenDocumentTitle}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default FaxCaseList;
